export class ServiceFee {
    id = null;
    code = null;
    name = null;
    description = null;
    fromDate = new Date();
    toDate = null;
    isUsing = null;
    price = null;
    serviceTypeId = null;
    serviceId = null;
    serviceType = null;
    service = null;
    fromQuantity = null;
    toQuantity = null;

    constructor(value) {
        Object.assign(this, value);

        if (!this.serviceType && Boolean(this?.service?.serviceType)) {
            this.serviceType = this.service.serviceType
        }

        if (!this.serviceTypeId && this.serviceType) {
            this.serviceTypeId = this.serviceType.id;
        }

        if (!this.serviceId && this.service) {
            this.serviceId = this.service.id;
        }
    }
}